import * as types from '../constants/actionTypes';
import {fetchStates as meta} from '../constants/actionMetaStates';
import initialState from '../store/initialState';

export default function roomReducer(state = {}, action) {
    switch(action.type) {
        case types.CLEAR_DATA:
        case types.CLEAR_ROOM_DATA:
            return initialState.rooms;

        case types.FETCH_ROOM_LIST_REQUEST:
            return {...state, ...meta.start};
        case types.FETCH_ROOM_LIST_SUCCESS:
            return {...state, ...meta.success, list: action.payload.data};
        case types.FETCH_ROOM_LIST_FAILURE:
            return {...state, ...meta.failure, list: action.payload.data};

        case types.FETCH_ROOM_EVENTS_REQUEST:
            return {...state, ...meta.start};
        case types.FETCH_ROOM_EVENTS_SUCCESS:
        case types.FETCH_ROOM_EVENTS_PARTIAL_SUCCESS:
            return {...state, ...meta.success, ...action.payload.data};
        case types.FETCH_ROOM_EVENTS_FAILURE:
            return {...state, ...meta.failure, ...action.payload.data};

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/roomReducer.js